import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Search, X } from 'lucide-react';

const EMOJI_CATEGORIES = [
  {
    id: 'recientes',
    label: 'Recientes',
    icon: '🕐',
    emojis: [] as string[],
  },
  {
    id: 'caras',
    label: 'Caras y emociones',
    icon: '😀',
    emojis: [
      '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩',
      '😘','😗','☺️','😚','😙','🥲','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔',
      '🤐','🤨','😐','😑','😶','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷',
      '🤒','🤕','🤢','🤮','🤧','🥵','🥶','🥴','😵','🤯','🤠','🥳','🥸','😎','🤓','🧐',
      '😕','😟','🙁','☹️','😮','😯','😲','😳','🥺','😦','😧','😨','😰','😥','😢','😭',
      '😱','😖','😣','😞','😓','😩','😫','🥱','😤','😡','😠','🤬','😈','👿','💀','☠️',
      '💩','🤡','👹','👺','👻','👽','👾','🤖','😺','😸','😹','😻','😼','😽','🙀','😿','😾',
    ],
  },
  {
    id: 'gestos',
    label: 'Gestos y personas',
    icon: '👋',
    emojis: [
      '👋','🤚','🖐️','✋','🖖','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆',
      '🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✍️',
      '💅','🤳','💪','🦵','🦶','👂','🦻','👃','🧠','🦷','🦴','👀','👁️','👅',
      '👶','🧒','👦','👧','🧑','👱','👨','🧔','👩','🧓','👴','👵','🙍','🙎','🙅','🙆',
      '💁','🙋','🧏','🙇','🤦','🤷','💆','💇','🚶','🧍','🧎','🏃','💃','🕺','🧖','🧗',
    ],
  },
  {
    id: 'animales',
    label: 'Animales y naturaleza',
    icon: '🐶',
    emojis: [
      '🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸',
      '🐵','🙈','🙉','🙊','🐒','🦆','🐦','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝',
      '🪱','🐛','🦋','🐌','🐞','🐜','🪲','🦟','🦗','🕷️','🦂','🐢','🐍','🦎',
      '🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐟','🐠','🐬','🐳','🐋','🦈','🐊',
      '🌸','🌺','🌻','🌹','🥀','🌷','🌱','🌿','☘️','🍀','🎋','🍃','🍂','🍁',
      '🍄','🌾','💐','🌵','🌴','🌳','🌲','🌙','⭐','🌟','💫','✨','☀️','🌤️',
    ],
  },
  {
    id: 'comida',
    label: 'Comida y bebida',
    icon: '🍔',
    emojis: [
      '🍎','🍊','🍋','🍇','🍓','🫐','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🫒',
      '🥑','🍆','🥦','🥬','🥒','🌽','🥕','🧅','🧄','🥔','🍠','🥐','🍞','🥖','🥨',
      '🧀','🥚','🍳','🥞','🧇','🥓','🥩','🍗','🍖','🌭','🍔','🍟','🍕','🌮','🌯',
      '🫔','🥙','🧆','🍱','🍘','🍙','🍚','🍛','🍜','🍝','🍢','🍣',
      '🍤','🍥','🥮','🍡','🥟','🥠','🥡','🦪','🍦','🍧','🍨','🍩','🍪','🎂','🍰',
      '🧁','🥧','🍫','🍬','🍭','🍮','🍯','🍼','🥛','☕','🫖','🍵','🧃','🥤','🧋',
      '🍶','🍺','🍻','🥂','🍷','🍸','🍹','🧉','🍾','🥄','🍴','🍽️','🥢','🫙',
    ],
  },
  {
    id: 'viajes',
    label: 'Viajes y lugares',
    icon: '✈️',
    emojis: [
      '🚗','🚕','🚙','🚌','🚎','🏎️','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🏍️',
      '🛵','🚲','🛴','🛹','🚁','🛸','🚀','✈️','🛩️','🛫','🛬','🛶','⛵',
      '🚤','🛥️','🛳️','⛴️','🚢','🚂','🚃','🚄','🚅','🚆','🚇','🚈','🚉','🚊','🚝',
      '🗺️','🧭','⛰️','🏔️','🌋','🗻','🏕️','🏖️','🏜️','🏝️','🏟️','🏛️','🏗️',
      '🏘️','🏚️','🏠','🏡','🏢','🏣','🏤','🏥','🏦','🏨','🏩','🏪','🏫','🏬','🏭',
      '🗼','🗽','⛪','🕌','🛕','🕍','⛩️','🕋','⛲','⛺','🌁','🌃','🌄','🌅','🌆','🌉',
    ],
  },
  {
    id: 'actividades',
    label: 'Actividades',
    icon: '⚽',
    emojis: [
      '⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🏓','🏸','🏒','🥊','🥋',
      '🎯','🪃','🏹','🎣','🤿','🥅','⛳','🪁','🎽','🎿','🛷','🥌','🎮','🕹️','🎲',
      '♟️','🎭','🎨','🖼️','🎰','🏋️','🤼','🤸','⛹️','🏊','🚣','🧗',
      '🎪','🤹','🎸','🎷','🎺','🎻','🪕','🥁','🎵','🎶','🎤','🎧','🎼','🎬','🎞️',
    ],
  },
  {
    id: 'objetos',
    label: 'Objetos',
    icon: '💡',
    emojis: [
      '⌚','📱','📲','💻','⌨️','🖥️','🖨️','🖱️','💾','💿','📀','📷','📸','📹','🎥',
      '📽️','🎞️','📞','☎️','📟','📠','📺','📻','🧭','⏱️','⏰','🕰️','⌛','⏳','📡',
      '🔋','🪫','🔌','💡','🔦','🕯️','🪔','💰','💵','💳','🪙','💎','⚖️','🔧','🔨',
      '🪛','🔩','⚙️','🗜️','🔗','⛓️','🧲','🪜','🪝','🧰','🔑','🗝️','🔐','🔒','🔓',
      '🚪','🪞','🪟','🛋️','🪑','🚽','🪠','🚿','🛁','🪤','🧴','💊','💉','🩺','🩹',
      '📦','📫','📬','📭','📮','📯','📜','📄','📑','🗒️','📆','📅','📇','📋','📁',
    ],
  },
  {
    id: 'simbolos',
    label: 'Símbolos',
    icon: '❤️',
    emojis: [
      '❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❤️‍🔥','❤️‍🩹','💕','💞','💓',
      '💗','💖','💘','💝','💟','☮️','✝️','☪️','🕉️','☸️','✡️','🔯','🕎','☯️','☦️',
      '🛐','⛎','♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓','🆔','⚛️',
      '🉑','☢️','☣️','📴','📳','🈶','🈚','🈸','🈺','🈷️','✴️','🆚','💮','🉐','㊙️',
      '✅','❎','🔴','🟠','🟡','🟢','🔵','🟣','⚫','⚪','🟤','🔺','🔻','🔷','🔶',
      '🔹','🔸','🔲','🔳','▪️','▫️','◾','◽','◼️','◻️','🟥','🟧','🟨','🟩','🟦','🟪',
      '⬛','⬜','🟫','🔱','📛','🔰','♻️','✔️','🔛','🔟','💯','🔠','🔡','🔣','🔤',
    ],
  },
  {
    id: 'banderas',
    label: 'Banderas',
    icon: '🏳️',
    emojis: [
      '🏳️','🏴','🏁','🚩','🏳️‍🌈','🏳️‍⚧️','🏴‍☠️',
      '🇦🇷','🇧🇷','🇨🇴','🇨🇱','🇲🇽','🇵🇪','🇻🇪','🇩🇴','🇨🇺','🇵🇷','🇺🇾','🇵🇾','🇧🇴','🇪🇨',
      '🇺🇸','🇬🇧','🇪🇸','🇫🇷','🇩🇪','🇮🇹','🇵🇹','🇯🇵','🇰🇷','🇨🇳','🇷🇺','🇦🇺','🇨🇦',
    ],
  },
];

const ALL_EMOJIS: string[] = EMOJI_CATEGORIES.slice(1).flatMap(c => c.emojis);

const RECENT_KEY = 'tolkx_emoji_recents';

const getRecents = (): string[] => {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch { return []; }
};

const saveRecent = (emoji: string) => {
  const prev = getRecents().filter((e: string) => e !== emoji);
  localStorage.setItem(RECENT_KEY, JSON.stringify([emoji, ...prev].slice(0, 24)));
};

interface Props {
  onEmojiClick: (emoji: string) => void;
  onClose: () => void;
}

const EmojiPickerCustom: React.FC<Props> = ({ onEmojiClick }) => {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('caras');
  const [recents, setRecents] = useState<string[]>(getRecents);
  const searchRef = useRef<HTMLInputElement>(null);
  const bodyRef = useRef<HTMLDivElement>(null);
  const categoryRefs = useRef<{ [id: string]: HTMLDivElement | null }>({});

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (!isMobile) searchRef.current?.focus();
  }, []);

  const handleEmoji = useCallback((emoji: string) => {
    saveRecent(emoji);
    setRecents(getRecents());
    onEmojiClick(emoji);
  }, [onEmojiClick]);

  const scrollToCategory = (id: string) => {
    setActiveCategory(id);
    categoryRefs.current[id]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleScroll = () => {
    const body = bodyRef.current;
    if (!body) return;
    const scrollTop = body.scrollTop;
    for (const cat of EMOJI_CATEGORIES) {
      const el = categoryRefs.current[cat.id];
      if (el && el.offsetTop - body.offsetTop <= scrollTop + 40) {
        setActiveCategory(cat.id);
      }
    }
  };

  const displayEmojis: string[] | null = search.trim()
    ? ALL_EMOJIS.filter((e: string) => e.includes(search))
    : null;

  const categoriesToShow = EMOJI_CATEGORIES.map(cat => ({
    ...cat,
    emojis: cat.id === 'recientes' ? recents : (cat.emojis as string[]),
  })).filter(cat => cat.id !== 'recientes' || cat.emojis.length > 0);

  return (
    <div
    className="ep-container"
    onMouseDown={e => e.preventDefault()}
    onTouchStart={e => e.preventDefault()}
  >
      <div className="ep-search-wrap">
        <Search size={14} className="ep-search-icon" />
        <input
          ref={searchRef}
          className="ep-search"
          placeholder="Buscar emoji..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          onMouseDown={e => e.stopPropagation()}
        />
        {search && (
          <button className="ep-search-clear" onClick={() => setSearch('')} onMouseDown={e => e.preventDefault()}>
            <X size={12} />
          </button>
        )}
      </div>

      {!search && (
        <div className="ep-tabs">
          {categoriesToShow.map(cat => (
            <button
              key={cat.id}
              className={`ep-tab ${activeCategory === cat.id ? 'ep-tab--active' : ''}`}
              onClick={() => scrollToCategory(cat.id)}
              title={cat.label}
            >
              {cat.icon}
            </button>
          ))}
        </div>
      )}

      <div className="ep-body" ref={bodyRef} onScroll={handleScroll}>
        {search ? (
          <div className="ep-section">
            <div className="ep-section__label">Resultados</div>
            <div className="ep-grid">
              {(displayEmojis ?? ALL_EMOJIS).map((emoji: string, i: number) => (
                <button
                  key={i}
                  className="ep-btn"
                  onMouseDown={e => e.preventDefault()}
                  onTouchStart={e => e.preventDefault()}
                  onClick={() => handleEmoji(emoji)}
                >
                  {emoji}
                </button>
              ))}
            </div>
            {displayEmojis !== null && displayEmojis.length === 0 && (
              <div className="ep-empty">No se encontraron emojis</div>
            )}
          </div>
        ) : (
          categoriesToShow.map(cat => (
            <div
              key={cat.id}
              className="ep-section"
              ref={el => { categoryRefs.current[cat.id] = el; }}
            >
              <div className="ep-section__label">{cat.label}</div>
              <div className="ep-grid">
                {cat.emojis.map((emoji: string, i: number) => (
                  <button
                    key={i}
                    className="ep-btn"
                    onMouseDown={e => e.preventDefault()}
                    onTouchStart={e => e.preventDefault()}
                    onClick={() => handleEmoji(emoji)}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default EmojiPickerCustom;
export { EmojiPickerCustom };